import { motocaddyBackendPortalRequest } from "../apiConfig";
import {  MCAdminUserCreate, MCAdminUserDetails, MCAdminUserList, MCAdminUserLogin, MCAdminUserUpdate } from "../apiRequest";


export const SignInMutation = async (body) => {
  const res = await motocaddyBackendPortalRequest(MCAdminUserLogin, {
    ...body,
  });
  return res.data;
};
export const GetProfileDetails  = async (id_adminuser,user) => {
  const res = await motocaddyBackendPortalRequest(MCAdminUserDetails,id_adminuser,user );
  return res.data;
};
export const CreateMCAdminUser  = async (body,user) => {
  const res = await motocaddyBackendPortalRequest(MCAdminUserCreate,body,user );
  return res.data;
};

export const UpdateMCAdminUser  = async (body,user) => {
  const res = await motocaddyBackendPortalRequest(MCAdminUserUpdate,body,user );
  return res.data;
};

export const AdminUserList = async (body,user) => {
  const res = await motocaddyBackendPortalRequest(MCAdminUserList,body,user );
  return res.data;
};

